import { AxiosInstance } from 'axios';
import { MembersRepository } from '@/model/repository/manager/members/MembersRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): MembersRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
    create(payload) {
      return Repository.post(`${resource}`, payload);
    },
    update(id, payload) {
      return Repository.put(`${resource}/${id}`, payload);
    },
    delete(id) {
      return Repository.delete(`${resource}/${id}`);
    },
  });
